// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Copy_wrapper__KpILa","tooltip":"Copy_tooltip__3QFTE","top":"Copy_top__MB0qZ","bottom":"Copy_bottom__Hb-za"};